import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addIssueTypes: {
		id: 'business-summary.summary-view.types-of-work.add-issue-types-button.add-issue-types-non-final',
		defaultMessage: 'Add an issue type',
		description: 'Label of link to add an issue type from the summary page',
	},
});
